// Generates a data-URL QR image for a URL suffix on the frontend origin

import { useEffect, useState } from 'react';
import { createLogger } from '@airhead-games/shared/utilities';
import { generateQrCode } from '@/utilities/generateQr';
import { getShareableFrontendUrl } from '@/utilities/getShareableFrontendUrl';

const logger = createLogger('useQrCode');

export function useQrCode(urlSuffix: string | undefined): string | undefined {
  const [qrCode, setQrCode] = useState<string | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!urlSuffix) {
        if (!cancelled) {
          setQrCode(undefined);
        }
        return;
      }
      try {
        const baseUrl = getShareableFrontendUrl();
        const url = `${baseUrl}${urlSuffix}`;
        const qrData = await generateQrCode(url);
        if (!cancelled) {
          setQrCode(qrData);
        }
      } catch (err) {
        logger.error('Failed to generate QR code:', err);
        if (!cancelled) {
          setQrCode(undefined);
        }
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, [urlSuffix]);

  return qrCode;
}
